<div [formGroup]="formGroup">
    <mat-form-field class="mat-form-field-fluid">
        <input matInput
            [formControlName]="controlName"
            [placeholder]="placeholder"
            [type]="type"
            [minlength]="minLength"
            [maxlength]="maxLength"
            #textInput    
            [mask]="mask"
            [showMaskTyped]="true">  
        <mat-hint *ngIf="showMaxLength" align="end">{{textInput.value.length}} / {{maxLength}}</mat-hint>
        <!-- errors -->
        <mat-hint *ngIf="formGroup.get(controlName).errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.email">{{'AUTH.VALIDATION.INVALID_EMAIL' | translate}} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.minlength">{{'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate | stringFormat: minLength}} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.max">{{'AUTH.VALIDATION.MAX_VALUE' | translate }} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.min">{{'AUTH.VALIDATION.MIN_VALUE' | translate }} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.pattern">{{'AUTH.VALIDATION.BAD_FORMAT' | translate }} &nbsp;</mat-hint>
        <mat-hint *ngIf="formGroup.get(controlName).errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint>
    </mat-form-field>  
</div>
 